/* ==========================================================================
   Bag delivery picker (2026-09-25, v10)
   Standalone module. No existing theme file or function is modified; this
   hooks in by watching #upass-skl for the .upl-cart-open class.

   WHERE EVERY NUMBER COMES FROM
   -----------------------------
   FREE date: Shopify's own Shop Promise estimate, fetched from the same
   Storefront endpoint Shopify's product-page widget uses
   (POST /api/unstable/graphql.json, query deliveryEstimates, token from the
   page's #shopify-features JSON). It accepts a postal code, so it works for
   a typed ZIP as well as the geo-detected one, and it returns the exact date
   checkout shows. Verified 2026-09-21: 91741 -> Wed Sep 23, matching the
   owner's checkout screenshot. Without a postal code it returns the
   geo-detected ZIP, which is how the ZIP gets prefilled.

   PAID prices: /cart/shipping_rates.json for the live cart, the same rates
   checkout offers, to the cent.

   PAID dates: NOT the rates API's delivery_date (it ignores the cutoff and
   disagreed with checkout on 3 of 4 services). Instead: ship day plus the
   carrier's guaranteed business days. Ship day is today before 3 PM PT on a
   business day (the page's cutoffTick() rule), else the next business day.
   Weekends and the six UPS holidays are skipped. Three cells, always: free,
   UPS 2nd Day Air, and next day (UPS Next Day Air Saver when the rates offer
   it, the cheaper next-business-day service; plain Next Day Air otherwise).
   A paid tier is shown only when its date BEATS the free date. v9 (earlier
   2026-09-25) showed ties too, which put "2-day air, Tue" next to "Free, Tue"
   for New York on a Friday; both dates were right (Promise says Tue, UPS's own
   quote says Tue) but a paid cell that arrives on the free day sells nothing
   and reads as a bug. v10 restores the guard. When no paid tier beats free the
   note reads "Free is already the fastest way to this ZIP".

   The block is an INDICATOR, not a selector. It never edits the bag's
   Shipping or Total lines; the customer picks the speed at checkout, where
   the same names, prices and dates appear.
   ========================================================================== */
(function(){
  var root = document.getElementById('upass-skl');
  if (!root || !window.fetch) return;

  var $ = function(id){ return document.getElementById(id); };
  var LS = 'uplZip';

  /* The rates endpoint rejects a bare ZIP with 422 "Select a state". */
  var ZIP_STATE = [
    [5,5,"NY"],[6,9,"PR"],[10,27,"MA"],[28,29,"RI"],[30,38,"NH"],[39,49,"MA"],[50,54,"VT"],
    [55,59,"MA"],[60,69,"CT"],[70,89,"NJ"],[100,149,"NY"],[150,196,"PA"],[197,199,"DE"],
    [200,205,"DC"],[206,219,"MD"],[220,246,"VA"],[247,268,"WV"],[270,289,"NC"],[290,299,"SC"],
    [300,319,"GA"],[320,349,"FL"],[350,369,"AL"],[370,385,"TN"],[386,397,"MS"],[398,399,"GA"],
    [400,427,"KY"],[430,459,"OH"],[460,479,"IN"],[480,499,"MI"],[500,528,"IA"],[530,549,"WI"],
    [550,567,"MN"],[570,577,"SD"],[580,588,"ND"],[590,599,"MT"],[600,629,"IL"],[630,658,"MO"],
    [660,679,"KS"],[680,693,"NE"],[700,714,"LA"],[716,729,"AR"],[730,749,"OK"],[750,799,"TX"],
    [800,816,"CO"],[820,831,"WY"],[832,838,"ID"],[840,847,"UT"],[850,865,"AZ"],[870,884,"NM"],
    [889,898,"NV"],[900,961,"CA"],[967,968,"HI"],[970,979,"OR"],[980,994,"WA"],[995,999,"AK"]
  ];
  var STATE_FULL = {
    AL:"Alabama",AK:"Alaska",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",
    CT:"Connecticut",DE:"Delaware",DC:"District of Columbia",FL:"Florida",GA:"Georgia",
    HI:"Hawaii",ID:"Idaho",IL:"Illinois",IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",
    LA:"Louisiana",ME:"Maine",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",
    MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",NH:"New Hampshire",
    NJ:"New Jersey",NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",
    OH:"Ohio",OK:"Oklahoma",OR:"Oregon",PA:"Pennsylvania",PR:"Puerto Rico",RI:"Rhode Island",
    SC:"South Carolina",SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",
    VA:"Virginia",WA:"Washington",WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming"
  };
  function stateFor(zip){
    var p = parseInt(String(zip).slice(0,3), 10);
    if (isNaN(p)) return null;
    for (var i=0;i<ZIP_STATE.length;i++){
      if (p >= ZIP_STATE[i][0] && p <= ZIP_STATE[i][1]) return STATE_FULL[ZIP_STATE[i][2]] || null;
    }
    return null;
  }

  /* Carrier service guarantees. Only these are ever offered as an upgrade:
     they are contractual service classes, not transit estimates. Order is
     fastest first. */
  var TIERS = [
    { re:/^UPS\s*Next Day Air Saver$/i, tag:"Next day air", days:1, rank:1, pref:1 },
    { re:/^UPS\s*Next Day Air$/i,       tag:"Next day air", days:1, rank:1, pref:2 },
    { re:/^UPS\s*2nd Day Air$/i,        tag:"2-day air",    days:2, rank:2, pref:1 }
  ];
  function tierFor(name){
    for (var i=0;i<TIERS.length;i++) if (TIERS[i].re.test(name)) return TIERS[i];
    return null;
  }

  var DOW = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  var MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  var MONFULL = ["january","february","march","april","may","june","july","august",
                 "september","october","november","december"];
  function fmtIso(iso){
    if (!iso) return null;
    var a = iso.split("-");
    var d = new Date(Date.UTC(+a[0], +a[1]-1, +a[2]));
    if (isNaN(d)) return null;
    return DOW[d.getUTCDay()] + ", " + MON[d.getUTCMonth()] + " " + d.getUTCDate();
  }
  function money(n){ return "$" + n.toFixed(2); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function strip(n){ return String(n).replace(/[®™]/g,'').replace(/\s+/g,' ').trim(); }

  /* Same cutoff rule the page's own cutoffTick() uses: weekdays before
     3 PM PT ship today. Read, not modified. */
  function cutoff(){
    try{
      var pt = new Date(new Date().toLocaleString('en-US', { timeZone:'America/Los_Angeles' }));
      var day = pt.getDay();
      var cut = new Date(pt); cut.setHours(15,0,0,0);
      if (day >= 1 && day <= 5 && pt < cut){
        var ms = cut - pt;
        return { today:true, h:Math.floor(ms/3600000), m:Math.floor(ms%3600000/60000) };
      }
    }catch(e){}
    return { today:false };
  }
  /* ---- business-day arithmetic (all in UTC-midnight dates) -------------- */
  function isoOf(d){
    return d.getUTCFullYear() + "-" + ("0"+(d.getUTCMonth()+1)).slice(-2) + "-" + ("0"+d.getUTCDate()).slice(-2);
  }
  /* UPS observes these six; no pickup or delivery. */
  function holiday(d){
    var m = d.getUTCMonth(), day = d.getUTCDate(), dow = d.getUTCDay();
    if (fixed(d, 0, 1) || fixed(d, 6, 4) || fixed(d, 11, 25)) return true; /* New Year, Jul 4, Christmas */
    if (m === 4 && dow === 1 && day >= 25) return true;         /* Memorial Day */
    if (m === 8 && dow === 1 && day <= 7) return true;          /* Labor Day */
    if (m === 10 && dow === 4 && day >= 22 && day <= 28) return true; /* Thanksgiving */
    return false;
  }
  /* A fixed-date holiday, observed Friday when it falls on Saturday and
     Monday when it falls on Sunday. */
  function fixed(d, m, day){
    var dow = d.getUTCDay();
    var t = new Date(d.getTime());
    if (dow === 5) t.setUTCDate(t.getUTCDate()+1);
    else if (dow === 1) t.setUTCDate(t.getUTCDate()-1);
    else t = d;
    return (d.getUTCMonth() === m && d.getUTCDate() === day && dow >= 1 && dow <= 5) ||
           (t !== d && t.getUTCMonth() === m && t.getUTCDate() === day);
  }
  function bizDay(d){ var w = d.getUTCDay(); return w >= 1 && w <= 5 && !holiday(d); }
  function addBiz(d, n){
    var x = new Date(d.getTime());
    while (n > 0){ x.setUTCDate(x.getUTCDate()+1); if (bizDay(x)) n--; }
    return x;
  }
  /* The day the order leaves: today before 3 PM PT on a business day,
     otherwise the next business day. Same rule as cutoff(). */
  function shipDate(){
    var pt;
    try { pt = new Date(new Date().toLocaleString('en-US', { timeZone:'America/Los_Angeles' })); }
    catch(e){ pt = new Date(); }
    var d = new Date(Date.UTC(pt.getFullYear(), pt.getMonth(), pt.getDate()));
    if (bizDay(d) && pt.getHours() < 15) return d;
    return addBiz(d, 1);
  }
  function arrivalIso(days){ return isoOf(addBiz(shipDate(), days)); }
  function cutoffLine(){
    var c = cutoff();
    if (!c.today) return 'Ships the next business day.';
    return 'Order within <b>' + c.h + 'h ' + (c.m < 10 ? '0' : '') + c.m + 'm</b> and it ships today.';
  }


  /* ---- Shop Promise: the same call Shopify's widget makes ---------------- */
  function jsonEl(id){
    try { var el = $(id); return el ? JSON.parse(el.textContent) : null; } catch(e){ return null; }
  }
  var PQ = 'query DeliveryEstimates($productVariantId: ID!, $countryCode: CountryCode, $postalCode: String, $isPostalCodeOverride: Boolean) {' +
    ' deliveryEstimates(productVariantId: $productVariantId, countryCode: $countryCode, postalCode: $postalCode, isPostalCodeOverride: $isPostalCodeOverride) {' +
    ' selectedShippingOption { maxDeliveryTime brandedPromise { handle lightLogo: compactLogo(theme: LIGHT) { url altText } } }' +
    ' deliveryAddress { zip timezone } deliveryDateMissingReason } }';
  function promiseQuery(zip){
    var feat = jsonEl('shopify-features'), prod = jsonEl('shop-promise-product');
    var tok = feat && feat.accessToken, vid = prod && prod.variantId;
    if (!tok || !vid) return Promise.reject(new Error('promise'));
    var vars = { productVariantId:'gid://shopify/ProductVariant/' + vid, countryCode:'US' };
    if (zip){ vars.postalCode = zip; vars.isPostalCodeOverride = true; }
    return fetch('/api/unstable/graphql.json', {
      method:'POST',
      headers:{ 'X-Shopify-Storefront-Access-Token':tok, 'content-type':'application/json' },
      body: JSON.stringify({ query:PQ, schemaHandle:'storefront', versionHandle:'unstable', variables:vars })
    }).then(function(r){ if (!r.ok) throw new Error('promise'); return r.json(); })
      .then(function(j){
        var d = j && j.data && j.data.deliveryEstimates;
        if (!d) throw new Error('promise');
        var o = d.selectedShippingOption || {}, out = { zip:null, iso:null, logo:null, brand:null };
        if (d.deliveryAddress && /^\d{5}$/.test(d.deliveryAddress.zip || '')) out.zip = d.deliveryAddress.zip;
        if (o.maxDeliveryTime){
          /* end-of-day stamp in the destination's zone; step back 12h so the
             UTC date is the local calendar day for every US zone */
          var t = Date.parse(o.maxDeliveryTime);
          if (!isNaN(t)) out.iso = isoOf(new Date(t - 12*3600000));
        }
        if (o.brandedPromise){
          out.brand = o.brandedPromise.handle || null;
          if (o.brandedPromise.lightLogo && o.brandedPromise.lightLogo.url) out.logo = o.brandedPromise.lightLogo.url;
        }
        return out;
      });
  }
  /* ZIP Shopify's widget already knows: its own storage, then ours */
  function knownZip(){
    var cands = [];
    /* explicit entries first (ours, then the widget's own ZIP form), then
       whatever Shopify detected for this visitor */
    try {
      var c = localStorage.getItem(LS); if (c) cands.push(c);
      var a = localStorage.getItem('delivery_promise_postal_code'); if (a) cands.push(a);
      var box = root.querySelector('.delivery-promise__promise-container');
      var m = box && (box.innerText || '').match(/\b(\d{5})\b/); if (m) cands.push(m[1]);
      var b = localStorage.getItem('delivery_promise_default_address'); if (b) cands.push(b);
    } catch(e){}
    if (window.UPL_ZIP_HINT) cands.push(String(window.UPL_ZIP_HINT));
    for (var i=0;i<cands.length;i++){
      var z = String(cands[i]).match(/\b(\d{5})\b/);
      if (z && stateFor(z[1])) return z[1];
    }
    return null;
  }

  /* ---- state ---------------------------------------------------------- */
  var S = { zip:null, freeIso:null, logo:null, free:null, ups:[], all:[],
            more:false, editing:false, loading:false, err:null };
  var cache = {};

  function choose(list){
    var free = null, i;
    for (i=0;i<list.length;i++){ if (list[i].p === 0){ free = list[i]; break; } }
    var tiered = [];
    for (i=0;i<list.length;i++){
      if (list[i].p <= 0) continue;
      var t = tierFor(list[i].n);
      if (t) tiered.push({ r:list[i], t:t });
    }
    /* one service per speed: the preferred (cheaper) one, then by price */
    tiered.sort(function(a,b){ return a.t.rank - b.t.rank || a.t.pref - b.t.pref || a.r.p - b.r.p; });
    var seen = {}, ups = [];
    for (i=0;i<tiered.length;i++){
      var x = tiered[i];
      if (seen[x.t.rank]) continue;
      seen[x.t.rank] = true;
      ups.push({ n:x.r.n, p:x.r.p, tag:x.t.tag, iso:arrivalIso(x.t.days), rank:x.t.rank });
    }
    /* v10: only speeds that arrive BEFORE the free (Shop Promise) date. A tie is not
       an upgrade; e.g. Friday to 10001, free Tue and UPS 2nd Day Air Tue: hide 2-day,
       keep next day (Mon). Without a Promise date every tier stays visible. */
    if (S.freeIso) ups = ups.filter(function(u){ return u.iso < S.freeIso; });
    /* cheaper, slower tier first so the ladder reads left to right */
    ups.sort(function(a,b){ return b.rank - a.rank; });
    return { free:free, ups:ups };
  }

  /* ---- fetch ---------------------------------------------------------- */
  function quote(zip){
    var prov = stateFor(zip);
    if (!prov) return Promise.reject(new Error('zip'));
    var u = '/cart/shipping_rates.json'
      + '?shipping_address%5Bzip%5D=' + encodeURIComponent(zip)
      + '&shipping_address%5Bcountry%5D=United+States'
      + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(prov);
    return fetch(u, { headers:{ 'Accept':'application/json' } })
      .then(function(r){
        if (!r.ok){ var e = new Error('rates'); e.status = r.status; throw e; }
        return r.json();
      })
      .then(function(j){
        return (j.shipping_rates || []).map(function(x){
          return { n:strip(x.presentment_name || x.name), p:parseFloat(x.price) };
        });
      });
  }
  /* The bag writes its line to the cart asynchronously after opening, so an
     early quote can come back empty. Ask again rather than give up. */
  function quoteRetry(zip, tries){
    return quote(zip).then(function(rates){
      if (rates && rates.length) return rates;
      if (tries <= 0){ throw new Error('rates'); }
      return new Promise(function(res){ setTimeout(res, 700); })
        .then(function(){ return quoteRetry(zip, tries-1); });
    }).catch(function(err){
      if (err && err.message === 'zip') throw err;
      if (tries <= 0) throw err;
      return new Promise(function(res){ setTimeout(res, 700); })
        .then(function(){ return quoteRetry(zip, tries-1); });
    });
  }

  var seq = 0;
  function load(zip){
    var my = ++seq;
    S.zip = zip; S.editing = false; S.err = null; S.more = false;
    try { localStorage.setItem(LS, zip); } catch(e){}
    var k = zip + '|' + ($('uplSub') ? $('uplSub').textContent : '');
    S.loading = true; render();
    var pP = (cache['P' + zip] ? Promise.resolve(cache['P' + zip]) : promiseQuery(zip).then(function(p){ cache['P' + zip] = p; return p; }))
      .catch(function(){ return null; });
    var pR = cache[k] ? Promise.resolve(cache[k]) : quoteRetry(zip, 3).then(function(r){ cache[k] = r; return r; });
    Promise.all([pP, pR]).then(function(res){
      if (my !== seq) return;
      var p = res[0];
      S.freeIso = p && p.iso ? p.iso : null;
      S.logo = p && p.logo ? p.logo : null;
      apply(res[1]);
    }).catch(function(err){
      if (my !== seq) return;
      if (window.UPL_DELIV_DEBUG) console.warn('[upl-deliv]', (err && err.stack) || err);
      S.loading = false;
      S.err = (err && err.message === 'zip') ? 'zip' : 'rates';
      render();
    });
  }
  function apply(rates){
    S.all = rates;
    var c = choose(rates);
    S.free = c.free; S.ups = c.ups; S.loading = false;
    render();
  }

  /* ---- render --------------------------------------------------------- */
  function hostEl(){
    var drf = root.querySelector('.upl-drf');
    if (!drf) return null;
    var box = $('uplDeliv');
    if (!box){
      box = document.createElement('div');
      box.id = 'uplDeliv';
      box.className = 'upl-deliv';
      drf.insertBefore(box, drf.firstChild);   /* above the totals */
      box.addEventListener('click', onClick);
      box.addEventListener('keydown', function(e){
        if (e.key === 'Enter' && e.target && e.target.id === 'uplZipIn'){ e.preventDefault(); submitZip(); }
      });
      box.addEventListener('input', function(e){
        if (!e.target || e.target.id !== 'uplZipIn') return;
        e.target.value = e.target.value.replace(/\D/g,'').slice(0,5);
        if (e.target.value.length === 5) submitZip();
      });
    }
    return box;
  }
  function submitZip(){
    var el = $('uplZipIn'); if (!el) return;
    var v = (el.value||'').replace(/\D/g,'').slice(0,5);
    if (v.length !== 5){ el.focus(); return; }
    if (!stateFor(v)){ S.err = 'zip'; render(); return; }
    load(v);
  }
  function onClick(e){
    var t = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!t) return;
    var a = t.getAttribute('data-act');
    if (a === 'more'){ S.more = true; render(); }
    else if (a === 'less'){ S.more = false; render(); }
    else if (a === 'edit'){ S.editing = true; render(); setTimeout(function(){ var i=$('uplZipIn'); if(i) i.focus(); }, 30); }
    else if (a === 'go'){ submitZip(); }
  }

  function promiseMark(){
    if (S.logo) return '<img class="upl-dv-promise" src="' + esc(S.logo) + '" alt="Shop Promise" width="72" height="12" loading="lazy">';
    return '<span class="upl-dv-promise upl-dv-promise-t">Shop Promise</span>';
  }

  function render(){
    var box = hostEl(); if (!box) return;
    var slot = $('uplPromiseSlot');
    if (slot){
      if (S.zip && !S.editing) slot.classList.add('upl-promise-absorbed');
      else slot.classList.remove('upl-promise-absorbed');
    }

    if (S.loading){
      box.innerHTML = '<div class="upl-dv-head"><span>Delivery' + (S.zip ? ' to ' + esc(S.zip) : '') + '</span></div>' +
        '<div class="upl-dv-wait" aria-live="polite">Checking delivery dates</div>';
      return;
    }
    if (S.editing || !S.zip || S.err === 'zip'){
      box.innerHTML = '<div class="upl-dv-head"><span>Where is it going?</span></div>' +
        '<div class="upl-dv-zip">' +
          '<input id="uplZipIn" type="text" inputmode="numeric" maxlength="5" ' +
            'placeholder="ZIP code" aria-label="ZIP code" value="' + esc(S.zip||'') + '">' +
          '<button type="button" data-act="go">Check</button></div>' +
        (S.err === 'zip'
          ? '<p class="upl-dv-note">That is not a US ZIP code. Five digits.</p>'
          : '<p class="upl-dv-note">See the day it arrives, free or faster.</p>');
      return;
    }
    if (S.err === 'rates' || !S.free){
      box.innerHTML = '<div class="upl-dv-head"><span>Delivery to ' + esc(S.zip) + '</span>' +
        '<button type="button" data-act="edit">Change</button></div>' +
        (S.freeIso
          ? '<p class="upl-dv-note">Free delivery by <b>' + esc(fmtIso(S.freeIso)) + '</b>. Faster options are priced at checkout.</p>'
          : '<p class="upl-dv-note">Free shipping applies. Delivery options are shown at checkout.</p>');
      return;
    }

    var freeWhen = fmtIso(S.freeIso);
    var html = '<div class="upl-dv-head"><span>Delivery to ' + esc(S.zip) + '</span>' +
      '<button type="button" data-act="edit">Change</button></div>' +
      '<div class="upl-dv-opts" role="list" aria-label="Delivery speeds">';

    html += '<div class="upl-dv-opt upl-dv-free" role="listitem">' +
      '<span class="upl-dv-top">Free' + (freeWhen ? '' : ' shipping') + '</span>' +
      '<span class="upl-dv-when">' + esc(freeWhen || 'In 1 to 5 days') + '</span>' +
      '<span class="upl-dv-cost">' + (freeWhen ? promiseMark() : 'Free') + '</span>' +
      '</div>';

    S.ups.forEach(function(u){
      html += '<div class="upl-dv-opt" role="listitem">' +
        '<span class="upl-dv-top">' + esc(u.tag) + '</span>' +
        '<span class="upl-dv-when">' + esc(fmtIso(u.iso)) + '</span>' +
        '<span class="upl-dv-cost">+' + money(u.p) + '</span>' +
        '</div>';
    });
    html += '</div>';

    html += '<p class="upl-dv-line" id="uplDvTick">' + cutoffLine() + '</p>';
    html += '<p class="upl-dv-note">' + (S.ups.length
      ? 'Pick your speed at checkout.'
      : 'Free is already the fastest way to this ZIP.') + '</p>';

    if (!S.more){
      html += '<button type="button" class="upl-dv-more" data-act="more">More options</button>';
    } else {
      var rows = S.all.slice().sort(function(a,b){ return a.p - b.p; });
      html += '<div class="upl-dv-all"><div class="upl-dv-allh">Every service to ' + esc(S.zip) + '</div><ul>';
      rows.forEach(function(r){
        var isFree = r.p === 0, tr = isFree ? null : tierFor(r.n);
        var when = isFree ? freeWhen : (tr ? fmtIso(arrivalIso(tr.days)) : null);
        html += '<li>' +
          '<span class="upl-dv-an">' + esc(isFree ? 'Free standard' : r.n) + '</span>' +
          '<span class="upl-dv-ap">' + (isFree ? 'Free' : money(r.p)) + '</span>' +
          '<span class="upl-dv-aw">' + (when ? esc(when) : 'Arrival shown at checkout') + '</span>' +
          '</li>';
      });
      html += '</ul><p class="upl-dv-note">Checkout confirms the arrival date for every option.</p>' +
        '<button type="button" class="upl-dv-more" data-act="less">Show fewer</button></div>';
    }

    box.innerHTML = html;
  }

  /* keep the countdown live while the bag is open */
  setInterval(function(){
    var el = $('uplDvTick');
    if (el && root.classList.contains('upl-cart-open')) el.innerHTML = cutoffLine();
  }, 30000);

  /* ---- open ----------------------------------------------------------- */
  var wasOpen = false, resolving = false;
  function onOpen(){
    var z = knownZip();
    if (z){ load(z); return; }
    if (S.zip){ render(); load(S.zip); return; }
    /* nothing known: ask Shopify where this visitor is */
    if (resolving) return;
    resolving = true;
    S.loading = true; render();
    promiseQuery(null).then(function(p){
      resolving = false;
      if (p && p.zip && stateFor(p.zip)){ load(p.zip); return; }
      S.loading = false; S.editing = false; render();
    }).catch(function(){
      resolving = false;
      S.loading = false; render();
    });
  }

  new MutationObserver(function(){
    var open = root.classList.contains('upl-cart-open');
    if (open && !wasOpen){ wasOpen = true; setTimeout(onOpen, 120); }
    else if (!open && wasOpen){ wasOpen = false; }
  }).observe(root, { attributes:true, attributeFilter:['class'] });
})();
